import { Dispatch, MutableRefObject, SetStateAction, useEffect, useRef } from "react"
import { initMap } from "../../services/mapUtils";
import { readUrlParams } from "../../services/urlParams";
import { setBoundsAndZoom, setContinentRefresher } from "../../store/weatherSearchSlice";
import { useAppDispatch } from "../useAppDispatch";
import { useAppSelector } from "../useAppSelector";


interface UseMapInitProps {
    mapRef: MutableRefObject<L.Map>;
    delayedRenderId: string;
    browser: boolean;
    idRef: MutableRefObject<string>;
    fromMainSearchForm: boolean;
    setMapInitialized: Dispatch<SetStateAction<boolean>>;
}

export const useMapInit = ({ mapRef, delayedRenderId, browser, idRef, fromMainSearchForm, setMapInitialized }: UseMapInitProps) => {
    const dispatch = useAppDispatch();

    const stateRenderId = useAppSelector(state => state.weatherSearch.delayedRenderId);

    const continent = useAppSelector(state => {
        return state.weatherSearch.searchProperties.continent.val as string
    });
    const mapInitializing = useRef<boolean>();

    // initialization
    useEffect(() => {
        if (!browser || mapRef.current || mapInitializing.current || !continent) {
            return;
        }
        // we are waiting for state to match provided id
        if (delayedRenderId && delayedRenderId != stateRenderId) {
            return;
        }
        mapInitializing.current = true;
        const { zoom: zoomFromParams, center: centerFromParams } = readUrlParams()
        const map = initMap({ mapId: idRef.current, fromMainSearchForm, continent, zoom: zoomFromParams as number, center: centerFromParams as number[] });
        const onZoomend = () => {
            const [bounds, zoom] = [map.getBounds(), map.getZoom()];
            // strange bug when changing from mobile<->desktop
            if (bounds.getNorth() - bounds.getSouth() < 0.00001) {
                setTimeout(onZoomend, 100);
            }
            else {
                dispatch(setBoundsAndZoom({ zoom, bounds: bounds?.toBBoxString() }));
            }

        }
        const onLoad = () => {
            mapRef.current = map;
            mapInitializing.current = false;
            setMapInitialized(true);
            if (!zoomFromParams || !centerFromParams) {
                dispatch(setContinentRefresher(Math.random().toString(16)));
            }
            const [bounds, zoom] = [map.getBounds(), map.getZoom()];
            dispatch(setBoundsAndZoom({ zoom, bounds: bounds?.toBBoxString() }));
        }
        map.on('zoomend', onZoomend)
        map.on('moveend', onZoomend);
        map.whenReady(onLoad);
    });
}